var _g, _rect, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_30594_87435)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 21,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 21,
    r: 11,
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30594_87435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30594_87435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 25.6L27.65 18.55L26.25 17.15L20.6 22.8L17.75 19.95L16.35 21.35L20.6 25.6ZM22 31C20.6167 31 19.3167 30.7375 18.1 30.2125C16.8833 29.6875 15.825 28.975 14.925 28.075C14.025 27.175 13.3125 26.1167 12.7875 24.9C12.2625 23.6833 12 22.3833 12 21C12 19.6167 12.2625 18.3167 12.7875 17.1C13.3125 15.8833 14.025 14.825 14.925 13.925C15.825 13.025 16.8833 12.3125 18.1 11.7875C19.3167 11.2625 20.6167 11 22 11C23.3833 11 24.6833 11.2625 25.9 11.7875C27.1167 12.3125 28.175 13.025 29.075 13.925C29.975 14.825 30.6875 15.8833 31.2125 17.1C31.7375 18.3167 32 19.6167 32 21C32 22.3833 31.7375 23.6833 31.2125 24.9C30.6875 26.1167 29.975 27.175 29.075 28.075C28.175 28.975 27.1167 29.6875 25.9 30.2125C24.6833 30.7375 23.3833 31 22 31Z",
    fill: "#0040BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_30594_87435",
    x: -7,
    y: -8,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_30594_87435"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.679321 0 0 0 0 0.553749 0 0 0 0 0.553749 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_30594_87435",
    result: "effect2_dropShadow_30594_87435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_30594_87435",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export default ForwardRef;